export default {"src":"/_next/static/media/choose.7ee3671a.svg","height":683,"width":683};